import authenticationActions from '../actions/authentication.actions';

const authenticationReducer = (state, action) => {
  switch (action.type) {
    case authenticationActions.AUTHENTICATION_SUCCESS:
      return Object.assign({}, { ...state }, { loggedIn: true });
    case authenticationActions.AUTHENTICATION_EXTERNAL_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { loggedIn: true, clientId: action.clientId },
      );
    case authenticationActions.NEW_USER_REQUEST:
      return Object.assign({}, { ...state }, { newUser: true });
    case authenticationActions.NEW_USER_SUCCESS:
      return Object.assign({}, { ...state }, { newUser: false });
    case authenticationActions.RESET_PASSWORD_REQUEST_SUCCESS:
      return Object.assign({}, { ...state }, { resetPasswordRequested: true });
    default:
      return state;
  }
};

export default authenticationReducer;
